import { Button, SxProps, Theme } from "@mui/material";

export const ButtonStyledText = ({
  theme,
  sx,
  children,
  fullWidth,
  disabled,
  usePrimaryColor,
  onClick,
  ...props
}: {
  theme: Theme;
  sx: SxProps<Theme>;
  children: any;
  fullWidth?: boolean;
  disabled?: boolean;
  usePrimaryColor?: boolean;
  onClick: () => void;
}) => {
  const fontColorByMode = theme.palette.mode === "dark" ? theme.palette.text.primary : null;
  const fontColor = usePrimaryColor ? theme.palette.text.primary : fontColorByMode;

  return (
    <Button
      variant={"text"}
      sx={{
        ...sx,
        color: fontColor
      }}
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
};

export const LoadingButtonStyledText = ({
  theme,
  sx,
  children,
  onClick,
  disabled,
  loading,
  fullWidth,
  ...props
}: {
  theme: Theme;
  sx?: SxProps<Theme>;
  children: any;
  onClick: () => void;
  fullWidth?: boolean;
  loading: boolean;
  disabled?: boolean;
}) => (
  <Button
    variant={"text"}
    sx={{ ...sx, color: theme.palette.mode === "dark" ? theme.palette.text.primary : null }}
    //   ...sx,
    //   color: null, ...theme.applyStyles("dark", { color: theme.palette.text.primary })
    disabled={disabled}
    loading={loading}
    fullWidth={fullWidth}
    onClick={onClick}
    {...props}
  >
    {children}
  </Button>
);
